import { ActionType, CipoTableOptions, TableRow } from '@shared/components/data-list/common';
import { CipoTextControl } from '@shared/components/fields/common/fields.model';
import { DropdownActionsEnum } from '@shared/consts';
import { uniqueKey } from 'highcharts';

export interface SOVCategoryGroup {
  id: number;
  name: string;
  disabled: boolean;
  isUsed?: boolean;
  createdOn?: Date;
  createdBy?: string;
  versionId?: number;
  categories?: SOVCategory[];
}

export interface SOVCategory {
  id: number;
  rootCategoryId: number;
  name: string;
  number: string;
  position: number;
  uniqueKey: string;
  isUsed: boolean;
  parentId?: number;
  groupName?: string;
  markedForDeletion?: boolean;
  modified?: boolean;
  visible?: boolean;
}

export interface SOVCategoryFormGroup {
  number: CipoTextControl;
  name: CipoTextControl;
}

export type SOVCategoryGroupRow = TableRow & SOVCategoryGroup;

export type SOVCategoryGroupActionType = ActionType<DropdownActionsEnum, SOVCategoryGroupRow>;
export type SOVCategoryGroupTableOptions = CipoTableOptions<SOVCategoryGroupActionType, SOVCategoryGroupRow>;
